import { createContext } from 'react';

import type { ClientDetailData } from 'api/client/models';
import type { GenericResponse } from 'commons/modules/generic-response';

export type ValueCustumer = {
  profile: string | null;
  clientId: number;
  contractId: number;
  fullName: string;
  clientRole: string;
  onboardingStep?: number;
  profileDescription?: string;
  taxPersonType: string;
};

export type CustomerType = {
  customer: ClientDetailData | null | undefined;
  sourceType: 'clientes' | 'fondos' | 'dashboard';
  screenKeyForPositionsPortafolio: string;
  screenKeyForPositionsMovements: string;
  screenKeyForPositionsYields: string;
  setCustomer: (value: ClientDetailData | null | undefined) => void;
  updateCustomer: (value: ValueCustumer) => Promise<{
    success: boolean;
    data?: ClientDetailData | null;
    errorMessage?: string;
  }>;
  updateCurrentCustomer: (value: any) => void;
  getClientDetailData: (value: {
    clientId: number;
    taxPersonType: string;
  }) => Promise<GenericResponse<ClientDetailData>>;
  resetCustomer: () => void;
};

const Customer = createContext<CustomerType>({} as CustomerType);

export default Customer;
